<template>
    
    <div>
        
        <div class="down">
            
            <el-table
                :data="runLog"
                ref="editTable"
                height="1100"
                border
                style="width: 100%;">
                <el-table-column
                type="index"
                width="50">
                </el-table-column>
                <el-table-column
                prop="timestamp"
                label="日期"
                width="180">
                </el-table-column>
               
                <el-table-column
                prop="level"
                label="级别"
                width="80">
                </el-table-column>
               
                <el-table-column
                prop="body"
                label="内容" 
                width="1200">
                </el-table-column>
                
                <el-table-column
                prop="threadName"
                label="线程"
                width="180">
                 </el-table-column>
                
                <el-table-column
                prop="className"
                label="类"
                width="550">
                </el-table-column>
            </el-table>
              <!--<video  src="https://xhlzn-test.oss-cn-hangzhou.aliyuncs.com/face_password.mp4" controls="controls" loop="loop" style="display:block;width:100%;" >您的浏览器不支持视频播放</video> -->

           <!-- <ul class="infinite-list" style="overflow:auto">
                <li v-for="(obj,index) in runLog"  v-bind:key="index" class="infinite-list-item" >{{ obj.body }}</li>
            </ul>-->
        </div>
    </div>
</template>
<script>
import {Message} from 'element-ui';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';

export default {
    
name:"version",
    data(){
        return {
            title:"后台运行日志",
            radio: 1,
            runLog:[],
            params:{}
        }
    },
    methods:{
     
        //初始化
            initWebSocket(){
                
                this.connection();

            },
            //建立连接
            connection() {
                // 建立连接对象
                //连接服务端提供的通信接口，连接以后才可以订阅广播消息和个人消息
                let _that=this;
                //后台服务ip和port
                _that.socket = new SockJS('https://api.hooply.net/hladmin/v1/websocket');
                // 获取STOMP子协议的客户端对象
                _that.stompClient = Stomp.over(_that.socket);
                // 向服务器发起websocket连接
                _that.stompClient.connect('guest','guest',(frame) => {
                    // 订阅服务端提供的某个topic
                    _that.stompClient.subscribe('/topic/pullLogger', (msg) => {
                        //msg.body存放的是服务端发送给我们的信息
                        let  resData= JSON.parse(msg.body);
                        _that.runLog.push(resData);
                        this.$nextTick(() => {  //设置滚动条一直在底部
                            this.$refs.editTable.bodyWrapper.scrollTop = this.$refs.editTable.bodyWrapper.scrollHeight;
                        })
               // var h = document.documentElement.scrollHeight || document.body.scrollHeight;
                //console.log("hhhhhhhhhhhhhhhhhhhhhhhhhhhhhh:"+h)
                // window.scrollTo(0,10000000000000000000000);
                       // console.log("asdasdassssssssssssssssss"+JSON.stringify(resData))
                    });
                }, (err) => {
                   
                    this.initWebSocket();
                });
 
            },
            disconnect() {
                if (this.stompClient != null) {
                    this.stompClient.disconnect();
                 
                }
            },
       
        //销毁页面之前，断开连接
        beforeDestroy: function () {
            //页面离开时断开连接,清除定时器
            this.disconnect();
            clearInterval(this.timer);
        },
        mounted(){
            //调用初始化websocket方法
            this.initWebSocket();
          
        },

       
    },
    created() {
      this.initWebSocket();
       
    },
    destroyed() {
      this.websock.close();//离开路由之后断开websocket连接
    }
}
</script>
<style>
    .infinite-list{
        border: rgba(92, 48, 145, 0.04);
       margin-top: 1%;
       margin-left: 10%;
    }
    .alal{
      background-image: url(../../assets/1231232.jpg);
        
    }
    .all{
       box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }
   
    .h1{
        font-style: initial;
        font-size: 50px;
    }
    .button{
        margin-top: 1%;
        margin-left: 20%;
    }
</style>